import React, {useEffect, useRef, useState} from "react";
import ReactOtpInput from "react-otp-input";
import { Alert, Button as BButton, Spinner } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Heading, OtpFooterContainer, SubHeading } from "./SignInOutForm.style";
import { memo } from "react";
import { email_reg, captchaKey } from "../../constants/Constant";
import t from "../../i18n/translate";
import reactStringReplace from "react-string-replace";
import ReCAPTCHA from "react-google-recaptcha";
import CloudflareTurnstile from "../../components/CloudflareTurnstile";
import * as Constants from "../../constants/Constant";

const isExpress = localStorage.getItem("expressMode");

const otpStyles = {
	container: {
		boxSizing: "border-box",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: "0.75rem",
		marginBlock: "2rem",
	},
	input: {
		boxSizing: "border-box",
		display: "inline-block",
		width: "clamp(2.75rem, 5vw, 3.125rem)",
		height: "clamp(2.75rem, 5vw, 3.125rem)",
		fontSize: "1.75rem",
		textAlign: "center",
		borderRadius: "0.175em",
		boxShadow: "0 0 0 1px #1e2723",
		border: "none",
		outline: "none",
		transition: "all 0.2s ease",
	},
	focus: {
		boxShadow: `0 0 0 2px ${isExpress ? "#f01266" : "#9cc54b"}`,
		transform: "scale(1.125)",
	},
};

export const OTPForm = ({
	OTP,
	otpKey,
	email,
	clock,
	alert,
	loading,
	alertMsg,
	setAlert,
	setClock,
	handleResendOTP,
	handleSubmitChangeOTP,
}) => {
	let minutes = Math.floor(clock / 60);
	let seconds = clock - Math.floor(clock / 60) * 60;
	const [token, setToken] = useState(null);

	const captcha = useRef(null);

	useEffect(() => {
		if (!otpKey) return;

		let countdown = setTimeout(() => {
			if (clock === 0) return;
			setClock(clock - 1);
		}, 1000);

		return () => clearTimeout(countdown);
	}, [clock, otpKey]);

	const otpSubTitleTran = t("verify_otp_sub_title", false);
	const otpSubTitleTranReplace = reactStringReplace(
		`${otpSubTitleTran}`,
		/({path})/g,
		() => (email_reg.test(email) ? t("email") : t("SMS"))
  );
  
  const onResendOTP = (e) => {
    if (!token) {
      window.alert("Please complete the captcha below.");
      return;
    }
    handleResendOTP(e, token);
  }
	const handleVerify = (token) => {
		setToken(token);
	}

	return (
		<>
			<Heading className={`${isExpress ? "express" : ""}`}>
				{t("verify_otp_title")}
			</Heading>
			<SubHeading>
				<FormattedMessage id="otpSubText" defaultMessage={otpSubTitleTranReplace} />
			</SubHeading>
			<form>
				<p>
					{t("verify_otp_description")}{" "}
					<span style={{ color: isExpress ? "#f01266" : "#9cc54b" }}>{email}</span>
				</p>
				<ReactOtpInput
					value={OTP}
					onChange={(otp) => handleSubmitChangeOTP(otp)}
					numInputs={6}
					shouldAutoFocus="true"
					containerStyle={otpStyles.container}
					inputStyle={otpStyles.input}
					focusStyle={otpStyles.focus}
				/>
				{loading ? (
					<Spinner
						animation="border"
						className="d-block mx-auto my-3"
						style={{ color: isExpress ? "#f01266" : "#9cc54b" }}
					/>
				) : (
					<Alert
						show={alert}
						variant="danger"
						dismissible
						onClose={() => setAlert(false)}
					>
						<p>{alertMsg}</p>
					</Alert>
				)}
				{clock === 0 ? (
				  // <ReCAPTCHA
				  //   className="d-block mb-3"
					// 			sitekey={captchaKey}
					// 			ref={captcha}
					// 			onChange={() => captcha.current.getValue()}
					// />
					<div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
						<CloudflareTurnstile
							sitekey={Constants.sitekey}
							onVerify={(token) => handleVerify(token)}
							onError={(error) => console.log(error)}
							className="turnstile-widget"
							style={{ backdropColor:"#ffffff" }}
						/>
					</div>
				) : null}
			</form>
			<OtpFooterContainer className={`${isExpress ? "express" : ""}`}>
				{clock > 0 && <p className="text-muted mr-2">{t("resend_code")}</p>}
				{clock === 0 ? (
					<button onClick={(e) => onResendOTP(e)}>{t("resend_code")}</button>
				) : (
					<span>
						0{minutes}:{seconds < 10 && "0"}
						{seconds}s
					</span>
				)}
			</OtpFooterContainer>
		</>
	);
};

export default memo(OTPForm);
